import { useAnalyticsQuery } from './useAnalyticsQuery';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export const useFirmalar = () => {
  return useAnalyticsQuery('firmalar', async ({ signal }) => {
    const token = localStorage.getItem('access_token');
    const res = await fetch(`${API}/api/firmalar`, {
      signal,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) return [];
    return res.json();
  }, []);
};
